import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
